<template>
  <section class="trial">
    <h1 class="trial__title">{{ $route.meta.title }}</h1>
    <div class="trial__switch">
      <h2>
        Задачи
        <Tooltip class="hidden-md-and-up">
          Дополнительные задания помогут укрепить знания и получить дополнительные очки
        </Tooltip>
      </h2>
      <Switcher v-model="activeSwitch" :data="switchData" />
      <Tooltip class="hidden-sm-and-down">
        Дополнительные задания помогут укрепить знания и получить дополнительные очки
      </Tooltip>
    </div>
    <Timer />
    <Card
      v-for="task in tasks"
      :key="task.id"
      class="trial__card"
      :class="`trial__card--${task.type}`"
    >
      <Lesson :task="task" @start="isOpenModalTest = true" />
    </Card>
    <ModalTest :visible.sync="isOpenModalTest" />
  </section>
</template>

<script>
import Tooltip from '@/components/Common/Tooltip'
import Card from '@/components/Common/Card'
import Switcher from '@/components/Common/Switcher'
import Timer from '@/components/Users/TrialLesson/Timer'
import Lesson from '@/components/Users/TrialLesson/Lesson'
import ModalTest from '@/components/Users/TrialLesson/ModalTest'

export default {
  name: 'index',
  components: { Timer, Switcher, Card, Tooltip, Lesson, ModalTest },
  data: () => ({
    activeSwitch: 0,
    isOpenModalTest: false,
    switchData: [
      {
        value: 0,
        label: 'Основные'
      },
      {
        value: 1,
        label: 'Дополнительные'
      }
    ],

    tasks: [
      {
        id: 1,
        number: 1,
        content: 'А, О, У, Э, И',
        type: 'letters',
        points: 5
      },
      {
        id: 2,
        number: 2,
        content: 'А, О, У, Э, И',
        type: 'content',
        points: 5
      },
      {
        id: 3,
        number: 3,
        content: 'А, О, У, Э, И',
        type: 'material',
        points: 5
      },
      {
        id: 4,
        number: 4,
        content: 'А, О, У, Э, И',
        type: 'test',
        points: 5
      }
    ]
  })
}
</script>

<style scoped lang="scss">
.trial {
  padding: 36px 48px !important;
  background-repeat: no-repeat;
  background-position: bottom right;
  background-image: url('/img/trial-background.svg?v=12');

  @include xl-and-down {
    padding: 16px !important;
    background-size: 80%;
    background-position: 190% 100%;
  }

  @include md-and-down {
    background-position: 32% 105%;
    padding: 0 16px 500px !important;
    background-size: 100%;
  }

  @include sm-and-down {
    padding: 0 16px 400px !important;
  }

  @include xs {
    padding: 0 16px 300px !important;
    background-size: 135%;
    background-position: 20% 105%;
  }

  &__title {
    font-weight: bold;
    font-size: 24px;
    letter-spacing: 0.35px;
    color: $luchmara;
    margin-bottom: 52px;

    @include md-and-down {
      margin-bottom: 16px;
    }
  }

  &__switch {
    display: flex;
    align-items: center;
    height: 32px;
    margin-bottom: 24px;

    @include md-and-down {
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 64px;
    }

    h2 {
      font-weight: bold;
      font-size: 24px;
      letter-spacing: 0.35px;
      margin-right: 16px;
      color: $french-gray;
      display: flex;
      align-items: center;

      @include md-and-down {
        margin-bottom: 16px;
      }

      button {
        display: flex;
        margin-left: 12px;
      }
    }
  }

  &__card {
    margin-top: 16px;
    width: 414px;
    background-color: $white;
    background-repeat: no-repeat;
    background-position: right;

    @include md-and-down {
      width: 100%;
    }

    &--letters {
      background-image: url('/img/letters-background.svg?v=3');
    }

    &--content {
      background-image: url('/img/content-background.svg?v=3');
    }

    &--test {
      background-image: url('/img/test-background.svg?v=3');
    }

    &--material {
      background-image: url('/img/material-background.svg?v=12');
    }
  }
}
</style>
